import { persist, get, post, patch, del, push } from '@/assets/js/util.js'

const data = {
    name: '',
    email: '',
    phone: '',
    address: '',
    shippingMethod: 'instant',
    paymentMethod: 'cod',
    items: []
}
const context = persist('cart', data)
export default context
